document.querySelectorAll(".faq-title .faq-button").forEach(el => {
  el.addEventListener('click',function (e) {
    
    var id_title_number = this.id.replace("faq-button", "");
    
    if (document.querySelector("#faq-panel" + id_title_number).hasAttribute("hidden")) {
        document.querySelector("#faq-panel" + id_title_number).removeAttribute("hidden");
      	document.querySelector("#faq-icon" + id_title_number).style.opacity = '0';
    } else {
    	document.querySelector("#faq-panel" + id_title_number).setAttribute("hidden", "");
      	document.querySelector("#faq-icon" + id_title_number).style.opacity = '1';
    }
  });
});